import { apiFetch } from './client';

const token = () => localStorage.getItem('token');

export const getMemberProfileSchema = () =>
  apiFetch('/member-profile/schema', { token: token() });

export const getPublicMembers = (page = 1, perPage = 20, query = '') => {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage)
  });
  const q = String(query || '').trim();
  if (q) {
    params.set('q', q);
  }
  return apiFetch(`/members?${params.toString()}`);
};

export const getMemberProfile = () =>
  apiFetch('/member/profile', { token: token() });

export const saveMemberProfile = (body) =>
  apiFetch('/member/profile', { method: 'POST', token: token(), body });

export const getAdminMemberProfile = (id) =>
  apiFetch(`/admin/members/${id}/profile`, { token: token() });

export const saveAdminMemberProfile = (id, body) =>
  apiFetch(`/admin/members/${id}/profile`, { method: 'POST', token: token(), body });

export const changeMemberPassword = (body) =>
  apiFetch('/member/change-password', { method: 'POST', token: token(), body });
